import {
    dataMap,
    navMap,
    headerActions,
    contactsActions,
    mainContactsActions,
    addressesActions,
    bankActions,
    backlink,
    routes,
    object,
    moreNav,
    agendaViewConfig,
    sellsyAdminCommonTabs,
    samTabs,
} from './ThirdMapping';

var entitiesTabs = [
    {
        label: Loc.g('Activité'),
        value: 'activity',
        entities: ['task', 'event', 'annotation', 'email', 'phonecall', 'people', 'marketing'],
    },
    {
        label: Loc.g('Éléments épinglés'),
        value: 'pinned',
        entities: ['task', 'event', 'annotation', 'email', 'phonecall', 'people', 'marketing'],
    },
    {
        label: Loc.g('Commentaires'),
        value: 'note',
        entities: ['annotation'],
        databot: 'est-overview__activity--comment-list',
    },
    {
        label: Loc.g('Emails'),
        value: 'email',
        entities: ['email'],
        databot: 'est-overview__activity--email-list',
    },
    {
        label: Loc.g('Tâches'),
        value: 'task',
        entities: ['task'],
        databot: 'est-overview__activity--task-list',
    },
    {
        label: Loc.g('Evènements'),
        value: 'event',
        entities: ['event'],
        databot: 'est-overview__activity--event-list',
    },
    {
        label: Loc.g('Appels'),
        value: 'phonecall',
        entities: ['phonecall'],
        databot: 'est-overview__activity--call-list',
    },
    {
        label: Loc.g('Marketing'),
        value: 'marketing',
        entities: ['marketing'],
        databot: 'est-overview__activity--marketing-list',
    },
];

var entitiesGroups = [
    {
        label: Loc.g('Activité'),
        value: 'clientActivity',
        entities: [
            'task',
            'event',
            'annotation',
            'email',
            'phonecall',
            'client',
            'timetracking',
            'ticket',
            'snippettracking',
            'marketing',
        ],
    },
    {
        label: Loc.g('Prospection'),
        value: 'prospection',
        entities: ['campaign', 'opportunity', 'estimate', 'propdocument'],
    },
    {
        type: 'component',
        component: 'timeline-author-filter',
        label: Loc.g('Collaborateurs'),
        value: 'authors',
        filter: true,
        entities: [],
        display: 'block',
    },
];

var defaultEntities = [
    'email',
    'phonecall',
    'client',
    'annotation',
    'event',
    'task',
    'timetracking',
    'ticket',
    'campaign',
    'opportunity',
    'estimate',
    'propdocument',
    'snippettracking',
    'marketing',
];

var forcedLabel = [
    {
        value: 'document',
        label: Loc.g('Mises à jour'),
    },
];

var availableStatCards = [
    'invoice_third',
    'estimate_third',
    'turnover_third',
    'top_selling_items_third',
    'sales_margin_third',
];

const databots = {
    activity: 'est-overview__menu--activity',
    informations: 'est-overview__menu--general-info',
    financialactivity: 'est-overview__menu--financial-info',
    contacts: 'est-overview__menu--contact-linked',
    addresses: 'est-overview__menu--address',
    customfields: 'est-overview__menu--cf',
    statistics: 'est-overview__menu--stat',
    opportunity: 'est-overview__menu--opportunity',
    estimate: 'est-overview__menu--document',
    invoice: 'est-overview__menu--document',
    delivery: 'est-overview__menu--document',
    order: 'est-overview__menu--document',
    creditnote: 'est-overview__menu--document',
    proforma: 'est-overview__menu--document',
    payments: 'est-overview__menu--payment',
    bankaccount: 'est-overview__menu--bank-account',
    recurring: 'est-overview__menu--recurring',
    mandates: 'est-overview__menu--mandate',
    timetracking: 'est-overview__menu--timetracking',
    tickets: 'est-overview__menu--ticket',
    project: 'est-overview__menu--project',
    proposal: 'est-overview__menu--proposal',
    emailingprofile: 'est-overview__menu--mailing-list',
    massmailingMailinglist: 'est-overview__menu--mailing-list',
    massmailingCampaignList: 'est-overview__menu--mailing-list',
    receipts: 'est-overview__menu--receipt',
    briefcase: 'est-overview__menu--briefcase',
    activitycommentadd: 'est-overview__activity--comment-add',
    emailadd: 'est-overview__activity--email-add',
    calladd: 'est-overview__activity--call-add',
    taskadd: 'est-overview__activity--task-add',
    eventadd: 'est-overview__activity--event-add',
    generalinfoedit1: 'est-overview__section--general-info-edit-1',
    generalinfoedit2: 'est-overview__section--general-info-edit-2',
    marketing: 'est-overview__section--marketing',
};

export {
    dataMap,
    navMap,
    headerActions,
    contactsActions,
    mainContactsActions,
    addressesActions,
    bankActions,
    backlink,
    routes,
    entitiesTabs,
    defaultEntities,
    entitiesGroups,
    forcedLabel,
    object,
    moreNav,
    availableStatCards,
    databots,
    agendaViewConfig,
    sellsyAdminCommonTabs,
    samTabs,
};
